// Convert USD to SEK for internal use (approximate rate: 1 USD = 10.5 SEK)
const USD_TO_SEK_RATE = 10.5;

// Default exchange rate (fallback if dynamic rate not available)
let currentExchangeRate = 1500;

// Function to update the exchange rate dynamically
export const setExchangeRate = (rate: number) => {
  currentExchangeRate = rate;
};

// Get current exchange rate
export const getExchangeRate = () => currentExchangeRate;

export const formatPrice = (priceInUSD: number): string => {
  const priceInIQD = Math.round(priceInUSD * currentExchangeRate);
  
  return `${priceInIQD.toLocaleString()} IQD • $${priceInUSD.toLocaleString()}`;
};

export const formatPriceWithRate = (priceInUSD: number, rate: number): string => {
  const priceInIQD = Math.round(priceInUSD * rate);
  
  return `${priceInIQD.toLocaleString()} IQD • $${priceInUSD.toLocaleString()}`;
};

export const formatMonthlyFee = (feeInUSD: number): string => {
  const feeInIQD = Math.round(feeInUSD * currentExchangeRate);
  
  return `${feeInIQD.toLocaleString()} IQD • $${feeInUSD.toLocaleString()}/mån`;
};

export const formatMonthlyFeeWithRate = (feeInUSD: number, rate: number): string => {
  const feeInIQD = Math.round(feeInUSD * rate);
  
  return `${feeInIQD.toLocaleString()} IQD • $${feeInUSD.toLocaleString()}/mån`;
};

// Convert USD price to SEK for database storage (maintaining compatibility)
export const convertUSDToSEK = (priceInUSD: number): number => {
  return Math.round(priceInUSD * USD_TO_SEK_RATE);
};

// Convert SEK price from database to USD for display
export const convertSEKToUSD = (priceInSEK: number): number => {
  return Math.round(priceInSEK / USD_TO_SEK_RATE);
};
